import type { JSX } from '@builder.io/qwik';
import { useContext } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import Embed from '~/components/Shared/Embeds/Embed';
import { AppDataContext } from '~/contexts/AppDataContext';

const disqusPropertiesData: Record<string, string> = {
  '130': 'fsarrowheadaddict.disqus.com',
  '385': 'winter-is-coming.disqus.com',
};

export default component$((): JSX.Element => {
  const {
    property,
    payloadToSSR: { canonicalURL, resourceID },
  } = useContext(AppDataContext);
  const disqusSource = disqusPropertiesData[property];

  if (!disqusSource) return <></>;

  const script = `
    var disqus_config = function () {
      this.page.url = '${canonicalURL}';  
      this.page.identifier = '${resourceID}';
    };
    (function() { 
      var d = document, s = d.createElement('script');
      s.src = 'https://${disqusSource}/embed.js';
      s.setAttribute('data-timestamp', +new Date());
      (d.head || d.body).appendChild(s);
    })();
  `;

  return (
    <Embed
      embed={`<div id="disqus_thread" class="pl-4 md:pl-20"></div>`}
      type='other'
      isLoadedProp='mmDisqusLoaded'
      loadScript={script}
      innerHtml={true}
      wrapper='div'
      timeout={1000}
    />
  );
});
